// Ionic
import { IonPage, IonButton, IonContent } from "@ionic/react";

function Buttons(props) {
  return (
    <IonPage>
      <IonContent fullscreen>
        <h1>Small Size</h1>
        <IonButton color="primary" size="small" shape="round">
          Primary
        </IonButton>
        <IonButton color="secondary" size="small" shape="round">
          Secondary
        </IonButton>
        <IonButton color="tertiary" size="small" shape="round">
          Tertiary
        </IonButton>

        <h1>Default Size</h1>
        <IonButton color="primary" shape="round">
          Primary
        </IonButton>
        <IonButton color="secondary" shape="round">
          Secondary
        </IonButton>
        <IonButton color="tertiary" shape="round">
          Tertiary
        </IonButton>

        <h1>Large Size</h1>
        <IonButton color="primary" size="large" shape="round">
          Primary
        </IonButton>
        <IonButton color="secondary" size="large" shape="round">
          Secondary
        </IonButton>
        <IonButton color="tertiary" size="large" shape="round">
          Tertiary
        </IonButton>
      </IonContent>
    </IonPage>
  );
}

export default Buttons;
